import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { GridSize } from "@mui/material";
import { IBank } from "../models/Bank/IBank";
import { IBankListPayload } from "../models/Bank/IBankListPayload";
import { IBankResponse } from "../models/Bank/IBankResponse";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IBankListPayload, IBankRequest, IBankResponse } from '../models/bank';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const BankService = {
  getBank: async (
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<IBankListPayload | IServerError | IResponse | IBankResponse[]> => {
    try {
      const response: AxiosResponse<IBankListPayload> =
        await http.get<IBankListPayload>(
          "/v1/bank/?client_id=" +
            "&order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size +
            "&search_query=" +
            data.search_query,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IBank | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IBank> = await http.get<IBank>(
        `/v1/bank/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IBank | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IBank> = await http.put<IBank>(
          `/v1/bank/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IBank> = await http.post<IBank>(
        `/v1/bank/`,
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBank: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/bank/${delPayload.bankId}/`,
      );

      if (response.status === 204) {
        return "Bank has been deleted successfully";
      } else if (response.status === 200) {
        return "Bank has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkBankes: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/bank/`, {
        data: requestPayload.bankIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetBankDDL: async (): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> =
      await http.get<any[]>(`/v1/bank/bank-ddl`);

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archiveBank: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/bank/${archivePayload.bankId}/`,
      );

      if (response.status === 201) {
        return "Bank has been archived successfully";
      } else if (response.status === 200) {
        return "Bank has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  verifyBankDetails: async (
    branchTransitNo: string | undefined,
    bankCode: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IBank | IServerError | IResponse | null | any> => {
    if (!branchTransitNo || !bankCode) return null;
    try {
      const response: AxiosResponse<IBank> = await http.get<IBank>(
        `/v1/branch/verify-bank?branch_transit_no=${branchTransitNo}&bank_code=${bankCode}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  bankOrBranchExists: async (
    bankFinancialNo: string | null,
    branchTransitNumber: string | null,
  ): Promise<any | IServerError | IResponse | null> => {
    if (!bankFinancialNo) return null;
    if (!branchTransitNumber) return null;
    try {
      const response: AxiosResponse<any[]> = await http.get<any[]>(
        `/v1/bank/verify-bank-or-branch?bank_financia_no=${bankFinancialNo}&branch_transit_no=${branchTransitNumber}`,
      );

      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch {}
  },
  // branchExists: async (
  //   branchTransitNo: string | null,
  // ): Promise<any | IServerError | IResponse | null> => {
  //   if (!branchTransitNo) return null;
  //   try {
  //     const response: AxiosResponse<any[]> = await http.get<any[]>(
  //       `/v1/branch/verify-branch?bank_financia_no=${branchTransitNo}`,
  //     );

  //     if (response.status === 200) {
  //       return response.data;
  //     }

  //     return {
  //       status: false,
  //       message: "Something went wrong please try again later.",
  //     };
  //   } catch {}
  // },
};
